import React, { useMemo } from 'react';
import cx from 'classnames';
import { ArcPseudoBg } from '../../../../../internal/ArcPseudoBg/index.js';
import styles from './index.module.scss.js';

const Background = ({
  className,
  style,
  isHovered,
  isActive,
  kind,
  ...props
}) => {
  const isHoverActive = useMemo(() => {
    if (kind === "default") {
      return isHovered && !isActive;
    }
    return isHovered || isActive;
  }, [isActive, isHovered, kind]);
  return /* @__PURE__ */ React.createElement(
    "span",
    {
      ...props,
      className: cx(styles.box, kind, className),
      style,
      "aria-hidden": true
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        className: cx(styles.normal, {
          [styles.green]: kind === "green" || kind === "green2",
          [styles.yellow]: kind === "yellow",
          [styles.green2]: kind === "green2"
        })
      }
    ),
    kind !== "yellow" ? /* @__PURE__ */ React.createElement(ArcPseudoBg, { isBgActive: isHoverActive, className: cx(styles.hover) }) : null,
    /* @__PURE__ */ React.createElement(
      "span",
      {
        className: cx(styles.active, {
          [styles[kind]]: kind
        }),
        style: {
          "--opacity": isActive ? 1 : 0
        },
        "data-kind": kind
      },
      kind === "shine" && /* @__PURE__ */ React.createElement(
        "span",
        {
          className: cx(styles.star, {
            [styles["star-active"]]: isActive
          })
        }
      )
    )
  );
};

export { Background };
//# sourceMappingURL=index.js.map
